import React, { useState } from 'react'
import { Box, Paper, Tabs, Typography, useTheme, Tab, Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';
import KenTable from '../../components/KenTable';



const useStyles = makeStyles(() => ({
    header: {
        fontSize: '18px',
        fontWeight: '500',
    },
    container: {
        borderRadius: '8px',
        background: '#ffffff',
        marginTop: '32px',
        minHeight: 'calc(100vh - 120px)',
        position: 'relative',
    },
    tabRoot: {
        textTransform: 'capitalize', // 👈 make labels capitalized
        fontSize: '16px',
        fontWeight: 500,
    },
    subHeader: {
        fontSize: '18px',
        fontWeight: 500,
        padding: '12px 16px',
    },
    ongoing: {
        background: "#BFCEFF",
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px 12px',
        borderRadius: '100px',
        width: 'fit-content',
        fontSize: '14px',

    },
    upcoming: {
        background: "#E6E6E8",
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px 12px',
        borderRadius: '100px',
        width: 'fit-content',
        fontSize: '14px',
    }
}));

// Custom TabPanel
interface TabPanelProps {
    children?: React.ReactNode;
    value: string;
    index: string;
}
const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
    return (
        <div hidden={value !== index}>
            {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
        </div>
    );
};

const Invigilation = () => {
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = useState('one');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const columns = [
        { field: "name", headerName: "Course name" },
        { field: "code", headerName: "Course code" },
        { field: "exam", headerName: "Semester" },
        { field: "type", headerName: "Type" },
        { field: "date", headerName: "Date" },
        { field: "time", headerName: "Time" },
        { field: "status", headerName: "Status" },

    ];
    const rows = [
        { id: 1, name: "Network Analysis & Synthesis", code: "ECE101", exam: "Semester I", type: "Theory", date: "13-08-2025", time: "09:00am", venue: "Room no.102", status: <Typography className={classes.ongoing}>Ongoing</Typography> },
        { id: 2, name: "Digital Signal Processing", code: "ECE102", exam: "Semester I", type: "Theory", date: "14-08-2025", time: "10:00am", venue: "Room no.103", status: <Typography className={classes.upcoming}>Upcoming</Typography> },
        { id: 3, name: "Microprocessors", code: "ECE103", exam: "Semester I", type: "Theory", date: "15-08-2025", time: "11:00am", venue: "Room no.104", status: <Typography className={classes.upcoming}>Upcoming</Typography> },

    ];


    return (
        <Box>
            <Paper className="d-flex justify-content-between align-items-center" sx={{ p: 2 }}>
                <Typography className={classes.header}>Invigilation</Typography>
            </Paper>

            <Box className={classes.container}>
                <Box sx={{ width: '100%' }}>
                    <Typography className={classes.subHeader}>Invigilation TimeTable</Typography>
                    <Divider />
                </Box>
                <Box p={4}>
                    <KenTable columns={columns} rows={rows} />

                </Box>
            </Box>
        </Box>
    );
};

export default Invigilation;
